<div *ngIf="!brandImage; else elseBlock" [ngClass]="{'product-img': maxHeightImage, 'product-img-main': !maxHeightImage}">
    <img [ngClass]="{'max-height-image': maxHeightImage}" [src]="imageUrl" alt="" (error)="showOnError()">
    <div class="product-label">
        <span *ngIf="discountPercentage > 0" class="sale">-{{discountPercentage}}%</span>
        <span *ngIf="isNewProduct" class="new">NEW</span>
        <span class="new">({{packSize}} x {{capacity}})</span>
    </div>
</div>
<ng-template #elseBlock>
    <img class="img-fluid brand" [src]="imageUrl" alt="" (error)="showOnError()">
</ng-template>
